import styled from 'styled-components';


const Overlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: ${({theme}) => theme.palette.secondary.dark};
    opacity: 0;
    z-index: 999;
    transition: opacity 300ms ease;
    display: flex;
    justify-content: center;
    align-items: center;

`;

export default Overlay;